package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project_content

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.marginBlock
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Floor
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Furniture
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.RestaurantProject
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Room
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.Separator
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project_content.design.RestaurantDesign
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px


@Composable
fun RestaurantProjectContent(
    windowSizeMode: WindowSizeModeEnum,
    selectedRestaurantProject: RestaurantProject?,
    selectedRoom: Room?,
    onMoveFurniture: (String, Int, Int, Int, Int, Int) -> Unit,
    onTransformFurniture: (String, Int, Int, Int, Int, Int,String?) -> Unit,
    showRestaurantFloorDialog: () -> Unit,
    showDeleteFloorDialog: (String?) -> Unit,
    showDeleteRoomDialog: (String?) -> Unit,
    showEditFloorDialog: (String?, Int?) -> Unit,
    createRoom: (String, String, String) -> Unit,
    updateRoom: (String, String) -> Unit,
    updateProject: (String) -> Unit,
    onSelectNewRoom: (Room?) -> Unit,
    onDeleteFurniture: (String) -> Unit,
    onCopyFurniture: (Furniture) -> Unit,
    onFurnitureFocus: (Furniture?) -> Unit,
) {
    Column(
        modifier= Modifier
            .autoResponsiveness()
            .thenIf(
                windowSizeMode== WindowSizeModeEnum.Desktop,
                Modifier
                    .margin(left = Dimen.mediumPadding)
                    .border(
                        width = Dimen.smallThickness,
                        style = LineStyle.Solid,
                        color = Theme.ActionDisabledBackground.rgb
                    )
                    .borderRadius(Dimen.semiLargeRadius)
                    .padding(
                        leftRight = Dimen.extraLargePadding,
                        bottom = Dimen.extraLargePadding,
                        top = Dimen.largePadding,
                    )
            )
            .fillMaxSize()
    )
    {
        Column(
            modifier = Modifier.fillMaxWidth()
        )
        {

            FloorItems(
                selectedRestaurantProject=selectedRestaurantProject,
                showRestaurantFloorDialog = {
                    showRestaurantFloorDialog()
                },
                showDeleteRoomDialog = {
                    showDeleteRoomDialog(it)
                },
                showDeleteFloorDialog = {
                    showDeleteFloorDialog(it)
                },
                onEditIconClick = {floorId:String?,floorNumber:Int?->
                    showEditFloorDialog(floorId,floorNumber)
                },
                createRoom = {caption:String,floorId:String,projectId:String->
                    createRoom(caption,floorId,projectId)
                },
                updateRoom = {caption:String,roomId:String->
                    updateRoom(caption,roomId)
                },
                updateProject={projectName:String->
                    updateProject(projectName)
                }

            )

            Separator()
        }


        RestaurantDesign(
            selectedRestaurantProject=selectedRestaurantProject,
            selectedRoom = selectedRoom,
            onUpdateFurniture = { id:String,
                                  offsetX:Int,
                                  offsetY:Int,
                                  rotationDeg:Int,
                                  width:Int,
                                  height:Int->
                onMoveFurniture(id,offsetX,offsetY,rotationDeg,width,height)
            },
            onTransformFurniture={id:String,
                                  offsetX:Int,
                                  offsetY:Int,
                                  rotationDeg:Int,
                                  width:Int,
                                  height:Int,
                                  objectKind:String?,
                                ->
                onTransformFurniture(id,offsetX,offsetY,rotationDeg,width,height,objectKind)

            },
            onSelectNewRoom = {
                onSelectNewRoom(it)
            },
            onFurnitureCopy = {
                onCopyFurniture(it)
            },
            onFurnitureDelete = {
                onDeleteFurniture(it)
            },
            onFurnitureFocus = {
                onFurnitureFocus(it)
            }
        )





    }


}



@Composable
private fun FloorItems(
    selectedRestaurantProject: RestaurantProject?,
    showRestaurantFloorDialog: () -> Unit,
    showDeleteFloorDialog: (String?) -> Unit,
    showDeleteRoomDialog: (String?) -> Unit,
    onEditIconClick: (String?, Int?) -> Unit,
    createRoom: (String, String, String) -> Unit,
    updateRoom: (String, String) -> Unit,
    updateProject: (String) -> Unit,
) {

    val floorsCountList = remember { mutableStateOf<List<Int>>(listOf()) }
    val selectedFloorsCount = remember { mutableStateOf(0) }

    LaunchedEffect(selectedRestaurantProject?.floors) {
        val floorCount = selectedRestaurantProject?.floors?.size ?: 0
        floorsCountList.value = (1..floorCount).toList()
        selectedFloorsCount.value = floorCount
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        MediumContentTitle(
            title = Strings.current().general,
        )

        Row(
            modifier = Modifier
                .margin(bottom = Dimen.extraLargePadding)
                .fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            CustomEditText(
                modifier = Modifier,
                label = Strings.current().projectName,
                value = selectedRestaurantProject?.caption ?: "",
                marginBottom = 0.px,
                marginRight = Dimen.largePadding,
                isRequired = false,
                hint = "",
                onFocusIn = {},
                onFocusOut = {
                    updateProject(it)
                },
                onInputChange = { _, _ ->

                },
            )

            DropDownItem(
                modifier = Modifier,
                itemWidth = Dimen.normalEditTextWidth2,
                options = floorsCountList.value,
                label = Strings.current().floors,
                selectedItem = selectedFloorsCount.value,
                displayText = {
                    if (it is Int)
                        it.toString() else ""
                },
                onOptionClick = {
                    if (it is Int)
                        selectedFloorsCount.value = it
                }
            )
        }

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .autoResponsiveness()
        )
        {
            selectedRestaurantProject?.floors
                ?.take(selectedFloorsCount.value)?.forEach { floor ->

                val newRoom = mutableStateOf("")
                Column(
                    modifier = Modifier
                        .margin(right = Dimen.extraExtraLargePadding))
                {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        MediumContentTitle(
                            title = "${Strings.current().floor} ${floor?.number}",
                        )

                        CustomIcon(
                            modifier = Modifier
                                .margin(leftRight = Dimen.semiNormalPadding),
                            icon = Res.PathIcon.edit,
                            tooltipText = Strings.current().edit,
                            onIconClick = {
                                onEditIconClick(floor?.id, floor?.number)
                            },
                        )

                        CustomIcon(
                            icon = Res.PathIcon.delete,
                            tooltipText = Strings.current().delete,
                            onIconClick = {
                                showDeleteFloorDialog(floor?.id)
                            },
                        )
                    }

                    floor?.rooms?.forEach { room ->
                        Row(
                            modifier = Modifier
                                .margin(
                                    bottom = Dimen.highLargePadding,
                                )
                                .fillMaxWidth(),
                            verticalAlignment = Alignment.Bottom
                        ) {
                            CustomEditText(
                                modifier = Modifier.fillMaxWidth(),
                                label = Strings.current().roomName,
                                value = room?.caption ?: "",
                                marginRight = Dimen.largePadding,
                                marginBottom = 0.px,
                                isRequired = false,
                                hint = "",
                                onFocusIn = { },
                                onFocusOut = {
                                    if (room?.id != null) {
                                        updateRoom(it, room.id)
                                    }
                                },
                                onInputChange = { _, _ -> },
                            )

                            CustomIcon(
                                icon = Res.PathIcon.largeClose,
                                onIconClick = {
                                    showDeleteRoomDialog(room?.id)
                                }
                            )
                        }
                    }

                    Row(
                        modifier = Modifier
                            .margin(bottom = Dimen.extraLargePadding)
                            .fillMaxWidth(),
                        verticalAlignment = Alignment.Bottom
                    ) {
                        CustomEditText(
                            modifier = Modifier.fillMaxWidth(),
                            label = Strings.current().newRoomName,
                            value = newRoom.value,
                            isRequired = false,
                            marginRight = Dimen.largePadding,
                            marginBottom = 0.px,
                            hint = Strings.current().writeNewRoomNameToAdd,
                            onFocusIn = {},
                            onFocusOut = {
                                if (floor?.id != null
                                    && floor.projectId != null
                                    && it.isNotBlank()
                                ) {
                                    createRoom(it, floor.id, floor.projectId)
                                    newRoom.value = ""
                                }
                            },
                            onInputChange = { value: String, _ ->
                                newRoom.value = value
                            },
                        )

                        CustomIcon(
                            icon = Res.PathIcon.verify,
                            iconColor = if (newRoom.value.isEmpty())
                                Theme.TextDisabled.hex
                            else Theme.SuccessMain.hex,
                            focusedColor = Theme.White.rgb,
                            hoveredColor = Theme.White.rgb,
                            onIconClick = {
                                if (floor?.id != null
                                    && floor.projectId != null
                                    && newRoom.value.isNotBlank()
                                ) {
                                    createRoom(newRoom.value, floor.id, floor.projectId)
                                    newRoom.value = ""
                                }
                            }
                        )
                    }
                }
            }
        }

        CustomButton(
            modifier = Modifier.margin(topBottom = Dimen.normalPadding),
            title = Strings.current().addFloor,
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick = { showRestaurantFloorDialog() },
        )
    }
}